module.exports = __webpack_public_path__ + "static/media/lkw-40t.b5ed2582.svg";